import { GameLogoModel } from './game-logo.model';

export class GameModel {

  /**
   * Constructor
   *
   * @param {string} title
   * @param {string} iHash
   * @param {string} theme
   * @param {string} video_code
   * @param {GameLogoModel} game_logo
   * @param {string} type
   * @param {string} game_periods_display
   * @param {number} active
   * @param {boolean} team_score_enabled
   * @param {string} period_unit
   */
  public constructor(
    public title: string = null,
    public iHash: string = null,
    public theme: string = null,
    public video_code: string = null,
    public game_logo: GameLogoModel = null,
    public type: string = null,
    public game_periods_display: string = null,
    public active: number = null,
    public team_score_enabled: boolean = true,
    public period_unit: string = 'weeks',
    public language: string = 'en',
  ) { }
}
